module.exports = __webpack_public_path__ + "static/fonts/Roboto-Medium.0b76306.otf";


//////////////////
// WEBPACK FOOTER
// ./src/views/sales/dashboard/assest/font/roboto/Roboto-Medium.otf
// module id = 2O2L
// module chunks = 0